export default function hasContent(html) {
  return html && html !== "<p></p>"
}